// extracted by mini-css-extract-plugin
export default {"container":"login_container__ZnbvE","wrapper":"login_wrapper__YsVK6","dot":"login_dot__b4779","animate":"login_animate__e7x8l"};